// Display config for how an embed_conversation ("Вбудований тест") block's
// walked question sequence renders in Preview - packed into this block's
// own already-existing `config` TEXT column instead of a separate entity,
// same reasoning as containers reusing this file's sibling
// (containerLayoutTypes.js) but with nothing to "hold children" here - one
// block configuring its own internal rendering, no new backend field
// needed at all.
//
// `displayMode` picks between two fundamentally different renderings:
//   - 'layout' (default) - every question shown at once, spatially
//     arranged per `layout`/the rest of the fields (grid/table/wrap/
//     flex_row - the exact same shape/engine as TopicContainer/
//     ExerciseTemplateContainer, see containerLayoutTypes.js).
//   - 'stepper' - one question at a time in a single square window, a
//     "Далі" button advancing through the same walked path in place -
//     genuinely different from the layout modes (stateful step-through,
//     not a CSS arrangement of everything at once), so it isn't itself one
//     of CONTAINER_LAYOUT_TYPES - EmbedConversationPreview.jsx branches on
//     `displayMode` before ever reaching ContainerLayout.
// `layout`/the layout-specific fields stay populated even while
// displayMode is 'stepper' (just unused) - switching back to 'layout'
// mode restores whatever arrangement was previously chosen instead of
// resetting it.

export const EMBED_LAYOUT_DEFAULT = { displayMode: 'layout', layout: 'wrap', minItemWidth: '100%', gap: '20px', justify: 'stretch' };

export const EMBED_DISPLAY_MODES = [
    { key: 'layout', label: 'Розкладка' },
    { key: 'stepper', label: 'Тест в одному вікні' },
];

export function parseEmbedLayoutConfig(configString) {
    if (!configString) return EMBED_LAYOUT_DEFAULT;
    try {
        const parsed = JSON.parse(configString);
        return parsed && typeof parsed === 'object' && parsed.layout ? parsed : EMBED_LAYOUT_DEFAULT;
    } catch (e) {
        return EMBED_LAYOUT_DEFAULT;
    }
}
